import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { UpdateEndpointRequest, IntegrationEndpointDto } from '../types/integrationHub';

/**
 * PUT /api/eraf/integration-hub/endpoints/{id} — 엔드포인트 수정 (INTEGRATION_MANAGE)
 */
export function useUpdateEndpoint() {
  const queryClient = useQueryClient();
  return useMutation<
    IntegrationEndpointDto,
    { code: string; message: string },
    { id: number; req: UpdateEndpointRequest }
  >({
    mutationFn: ({ id, req }) => integrationHubApi.updateEndpoint(id, req),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'endpoints'] });
    },
  });
}
